import { useEffect, useRef } from 'react';
import { dialogRestoreTarget, dialogTabWrapTarget, isTopVisibleDialog } from './dialog-tab-stops';

/** Focus ownership only; each dialog keeps its existing close/draft policy. */
export function useModalFocus() {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const opened = ref.current;
    opened?.focus({ preventScroll: true });
    const keydown = (event: KeyboardEvent) => {
      const root = ref.current;
      if (event.key !== 'Tab' || event.defaultPrevented || !root || !isTopVisibleDialog(root))
        return;
      const target = dialogTabWrapTarget(root, document.activeElement, event.shiftKey);
      if (target) {
        event.preventDefault();
        event.stopPropagation();
        target.focus();
      }
    };
    document.addEventListener('keydown', keydown);
    return () => {
      document.removeEventListener('keydown', keydown);
      dialogRestoreTarget(opened, previous, document.activeElement, document.body)?.focus({
        preventScroll: true,
      });
    };
  }, []);
  return ref;
}
